<cds-layout>
  <cds-header
    header
    [userName]="userName"
    [isHelpIconPresent]="true"
    (logoutClick)="logout()"
    (helpIconClick)="getFeedbackWidget()">
    <div class="logo-container" data-test-data="logo-container" headerLogo>
      @if(shouldCheckUnderwriterUrl() && shouldCheckUnderwriterCondition()) {
      <span>
        <span class="logo">Vallia</span>
        <span class="text-logo">Assist</span>
      </span>
      <span class="text-logo">Underwriter</span>
      } @else {
      <span>
        <span class="logo">Vallia</span>
      </span>
      <span class="text-logo">DocFlow</span>
      }
    </div>
  </cds-header>

  <vallia-doc-flow-left-menu pageContent></vallia-doc-flow-left-menu>

  <div class="appl-content" pageContent>
    <div class="overflow-wrapper">
      <router-outlet> </router-outlet>
    </div>
  </div>
</cds-layout>
